// removed by extract-text-webpack-plugin
module.exports = {"controls":"cancel-subscription-modal__controls___2JHXd"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/cancel-subscription-modal.scss
// module id = 1357
// module chunks = 0